import { MutableRefObject } from 'react';
import { useDatasetDataRes } from '../../api/types/types';

// The datasetData effect syncs the ref only on the next render, so a caller
// awaiting a fetch (reload -> locate, loadMoreData) still reads the pre-fetch
// id and keeps hitting the stale server cache — write it as the response lands.
// Lazy responses must NOT touch the ref: the effect compares them against it to
// decide append vs. replace.
export const syncCachedQueryIdRef = (
  res: useDatasetDataRes,
  lazy: boolean,
  cachedQueryIdRef: MutableRefObject<string>,
  // Dataset the grid currently shows — same guard as the datasetData effect, so
  // a response for a dataset we already left can't write the ref.
  currentDatasetId: string | null | undefined
): void => {
  if (lazy || res?.cachedQueryId === undefined) {
    return;
  }
  if (res.datasetId !== currentDatasetId) {
    return;
  }
  cachedQueryIdRef.current = res.cachedQueryId;
};
